import { render, staticRenderFns } from "./OrgSchool.vue?vue&type=template&id=73f37fe8&scoped=true"
import script from "./OrgSchool.vue?vue&type=script&lang=js"
export * from "./OrgSchool.vue?vue&type=script&lang=js"
import style0 from "./OrgSchool.vue?vue&type=style&index=0&id=73f37fe8&prod&lang=scss&scoped=true"
import style1 from "./OrgSchool.vue?vue&type=style&index=1&id=73f37fe8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f37fe8",
  null
  
)

export default component.exports